import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import Wizard from 'modules/trainings/pages/MyTrainings/Requests/Wizard'

export const CreateTrainingRequestActivity: ActivityComponent = () => {
  const { open, closeActivity } = useActivity()

  return <Wizard isOpen={open} onClose={closeActivity} />
}
